import { Link } from '@tanstack/react-router'

export type NavigationItemProps = {
    children: React.ReactNode;
    isSelected?: boolean;
    target: string;
}

export default function NavigationItem({ children, isSelected = false, target }: NavigationItemProps) {
    return (
        <Link to={target}>
            <div className='relative h-full flex items-center justify-center cursor-pointer px-3 py-1.5 rounded-lg transition-colors hover:bg-gray-700/50'>
                <span className='text-foreground data-[selected=true]:text-orange-500 data-[selected=true]:font-bold' data-selected={isSelected}>{children}</span>
            </div>
        </Link>
    )
}